<script>
export default {
  methods: {
    createClustersAndEntitiesList: function (clusters = [], entities = []) {
      let options = []

      // Make a copy instead of updating the original references
      clusters = JSON.parse(JSON.stringify(clusters))
      entities = JSON.parse(JSON.stringify(entities))

      if (Array.isArray(clusters) && clusters.length > 0) {
        options.push({ name: `${this.$t('clusters.labels.clusters').toUpperCase()}  📁`, $isDisabled: true })

        clusters = clusters
          .map(element => {
            return {
              ...element,
              uid: `c${element.id}`,
              entitiesWithPermissions: element.entitiesIds.filter(id => element.entities.some(entity => entity.id === id)).length
            }
          })
          .filter(element => element.entitiesIds.length > 0)
          .sort((a, b) => {
            if (a.entitiesWithPermissions === b.entitiesWithPermissions) {
              return a.name.localeCompare(b.name)
            } else {
              return b.entitiesWithPermissions - a.entitiesWithPermissions
            }
          })

        options = options.concat(clusters)
        options.push({ name: this.$t('clusters.labels.entities').toUpperCase(), $isDisabled: true })
      }
      let clustersEntities = []
      if (Array.isArray(clusters) && clusters.length > 0) {
        clustersEntities = clusters.map(cluster => {
          let entity = []
          if (Array.isArray(cluster.entities) && cluster.entities.length > 0) {
            entity = cluster.entities.map(entity => {
              return {
                ...entity,
                uid: `c${entity.id}`,
                customname: `name${entity.id}`
              }
            })
            .sort((a, b) => a.name.localeCompare(b.name))
          }
          return entity
        })
      }
      clustersEntities = clustersEntities.flat(1)

      if (Array.isArray(entities) && entities.length > 0) {
        entities = entities
          .map(element => { return { ...element, uid: `e${element.id}` } })
          .sort((a, b) => a.name.localeCompare(b.name))
        entities = entities.concat(clustersEntities)
        options = options.concat(entities)
      }
      else {
        options = options.concat(clustersEntities)
      }

      return options
    },
    reloadSelectedClustersAndEntities: function (options, uids) {
      const uniqueUids = [...new Set(uids)]
      return options.filter(option => uniqueUids.includes(option.uid))
    },
    getSelectedOptionsIdsAndUids: function (options) {
      let selectedOptions = {
        ids: new Set(),
        uids: new Set()
      }

      options.forEach(element => {
        if (element.hasOwnProperty('entitiesIds')) {
          element.entitiesIds.forEach(id => selectedOptions.ids.add(id))
        } else {
          selectedOptions.ids.add(element.id)
        }
        selectedOptions.uids.add(element.uid)
      })

      selectedOptions.ids = [...selectedOptions.ids]
      selectedOptions.uids = [...selectedOptions.uids]

      return selectedOptions
    },

    createClustersAndEntitiesListSearch: function (clusters = [], entities = [] , search_query) {
      let options = []
      clusters = JSON.parse(JSON.stringify(clusters))
      entities = JSON.parse(JSON.stringify(entities))
      if (Array.isArray(clusters) && clusters.length > 0) {
        options.push({ name: `${this.$t('clusters.labels.clusters').toUpperCase()}  📁`, $isDisabled: true })
        let newClusters = []
        clusters.forEach(cluster => {
          if(cluster.entities.some(item => item.name.toLowerCase().includes(search_query.toLowerCase())) || cluster.name.toLowerCase().includes(search_query.toLowerCase()) || search_query === ""){
            newClusters.push({
              ...cluster,
              uid: `c${cluster.id}`,
              entitiesWithPermissions: cluster.entitiesIds.filter(id => cluster.entities.some(entity => entity.id === id)).length,
            })
          }
        })
        clusters = newClusters.filter(element => element.entitiesIds.length > 0)
        .sort((a, b) => {
          if (a.entitiesWithPermissions === b.entitiesWithPermissions) {
            return a.name.localeCompare(b.name)
          } else {
            return b.entitiesWithPermissions - a.entitiesWithPermissions
          }
        })

        options = options.concat(clusters)
        options.push({ name: this.$t('clusters.labels.entities').toUpperCase(), $isDisabled: true })
      }


      let clustersEntities = []
      if (Array.isArray(clusters) && clusters.length > 0) {
        clustersEntities = clusters.map(cluster => {
          let entities = []
          if (Array.isArray(cluster.entities) && cluster.entities.length > 0) {
            cluster.entities.forEach(item => {
              if(item.name.toLowerCase().includes(search_query.toLowerCase()) || search_query === ""){
                entities.push({
                  ...item,
                  uid: `c${item.id}`,
                })
              }
            })
            entities.sort((a, b) => a.name.localeCompare(b.name))
          }
          return entities
        })
        clustersEntities = clustersEntities.flat(1)
      }

      if (Array.isArray(entities) && entities.length > 0) {
        let newentities = []
        entities.forEach(item => {
          if(item.name.toLowerCase().includes(search_query.toLowerCase()) || search_query === ""){
            newentities.push({
              ...item,
              uid: `c${item.id}`,
            })
          }
        })
        newentities.sort((a, b) => a.name.localeCompare(b.name))
        entities = newentities
        entities = entities.concat(clustersEntities)
        options = options.concat(entities)
      }
      else {
        options = options.concat(clustersEntities)
      }
      return options
    },
  }
}
</script>
